<template>
  <div class="rr-image-upload-write-review container">
    <h3>{{ dictionary.Title }}</h3>
    <div class="rr-image-upload-write-review container-output">
      <ul class="rr-image-upload-write-review container-thumbnail">
        <li
          v-for="(item, index) in cachedImages"
          :key="index"
          class="rr-image-upload-write-review img-thumbnail"
        >
          <img :height="scss.imgSize" :width="scss.imgSize" :src="item" alt="" />
          <button
            type="button"
            class="rr-image-upload-write-review btn-close"
            aria-label="Close"
            @click="removeImage($event, index)"
          >
            x
          </button>
        </li>
      </ul>
    </div>
    <div class="rr-image-upload-write-review container-input">
      <span v-show="displayWarning" class="rr-image-upload-warning">{{ messageWarning }}</span>
      <input
        id="rr-fileUpload"
        class="rr-image-upload-write-review rr-file-upload"
        type="file"
        :accept="fileTypes"
        :size="config.AllowedImageSize"
        :maxFiles="config.AllowedImages"
        multiple
        @change="onFileChange($event)"
      />
    </div>
    <div class="rr-image-upload-write-review container-info">
      <h4>{{ dictionary.GuidelinesHeader }}</h4>
      <p>{{ dictionary.Guidelines }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'rfp-image-upload',
  props: {
    config: {
      type: Object,
      required: false,
      default() {
        return {
          AllowedImageSize: 1000,
          AllowedImages: 5,
          AllowedImageTypes: ['image/jpg', 'image/jpeg', 'image/png'],
        };
      },
    },
    scss: {
      type: Object,
      required: false,
      default() {
        return {
          primaryColor: '#F5A',
          secondaryColor: '#52A',
          defaultColor: '#FFF',
          imgSize: 110,
        };
      },
    },
    dictionary: {
      type: Object,
      required: false,
      default(props) {
        // vue 2 compatibility
        // eslint-disable-next-line vue/no-deprecated-props-default-this
        const config = props?.config || this?.config || {};
        return {
          Title: 'Upload Images',
          GuidelinesHeader: 'Photo Guidelines',
          Guidelines: `Number of images allowed: ${config.AllowedImages} images
                       Images types allowed: ${[...config.AllowedImageTypes]}
                       Image size allowed: ${config.AllowedImageSize} KB
                       You may only submit copyrighted images if you are the copyright owner.
                       Offensive images will be rejected. Uploaded Images become property of the company.`,
          AllowedImageSizeWarning: 'Image size too big',
          AllowedNumberOfImagesWarning: 'Images limit reached',
          AllowedImageTypesWarning: 'Format not supported',
          DuplicateImageWarning: 'Image already uploaded',
        };
      },
    },
  },
  data() {
    return {
      cachedImages: [],
      messageWarning: '',
      displayWarning: false,
      fileSize: this.multiplyByBytes(this.config.AllowedImageSize),
      fileTypes: this.supportedFormats(this.config.AllowedImageTypes),
    };
  },
  methods: {
    onFileChange(e) {
      e.preventDefault();
      this.displayWarning = false;
      if (this.checkFilesLimit(e.target.files.length)) {
        Array.from(e.target.files).forEach((e) => {
          if (this.checkSupportedFormat(e.type)) {
            if (this.checkSizeLimit(e.size)) {
              const reader = new FileReader();
              reader.readAsDataURL(e);
              reader.onload = (c) => {
                if (!this.checkDuplicate(this.cachedImages, c.target.result)) {
                  this.createWarning(this.dictionary.DuplicateImageWarning);
                } else if (this.limitReached()) {
                  this.createWarning(this.dictionary.AllowedNumberOfImagesWarning);
                } else {
                  this.cachedImages.push(reader.result);
                }
              };
            } else {
              this.createWarning(this.dictionary.AllowedImageSizeWarning);
            }
          } else {
            this.createWarning(this.dictionary.AllowedImageTypesWarning);
          }
        });
      } else {
        this.createWarning(this.dictionary.AllowedNumberOfImagesWarning);
      }
      window.imgStorage = this.cachedImages;
      document.querySelector('#rr-fileUpload').value = '';
    },
    removeImage(e, p) {
      e.preventDefault();
      this.displayWarning = false;
      this.cachedImages.splice(p, 1);
      if (this.cachedImages.length < 1) {
        document.querySelector('#rr-fileUpload').value = '';
      }
    },
    checkFilesLimit(e) {
      return e <= this.config.AllowedImages;
    },
    checkSizeLimit(e) {
      return e <= this.fileSize;
    },
    limitReached() {
      return this.cachedImages.length >= this.config.AllowedImages;
    },
    checkSupportedFormat(e) {
      return this.config.AllowedImageTypes.indexOf(e) > -1;
    },
    supportedFormats(e) {
      return `${[...e]}`;
    },
    multiplyByBytes(e) {
      return e * 1000;
    },
    createWarning(e) {
      this.messageWarning = e;
      this.displayWarning = true;
    },
    checkDuplicate(arr, i) {
      return !arr.includes(i);
    },
  },
};
</script>
